/* tslint:disable */
/* eslint-disable */
export enum WorkCatalogItemPromotionStatusEnum {
  Created = 'created',
  AlreadyExists = 'alreadyExists',
  NotFound = 'notFound'
}
